<template>
  <div class="p-3 row">
    <div v-if="settingsFiltered.length" class="col-12 col-xl-7 min-h-100">
      <el-form ref="form" @submit.prevent.native="onSubmit">
        <div v-for="formItem in form" :key="formItem.parameterId" class="row mb-3">
          <h4 class="col-7">{{formItem.parameterDescription}}</h4>
          <div class="col-5">
            <el-input v-if="[ParameterValueTypeEnum.integer].includes(formItem.parameterValueType)"
                      v-model.number="formItem.parameterValueGeneral" placeholder="Например: 20"/>

            <el-switch v-else-if="[ParameterValueTypeEnum.boolean].includes(formItem.parameterValueType)"
                       v-model="formItem.parameterValueGeneral" />

            <el-input v-else v-model="formItem.parameterValueGeneral" placeholder=""/>
          </div>
        </div>
      </el-form>
      <div class="d-flex justify-content-end mt-3">
        <el-button type="primary" size="medium" :loading="updateSettingsProgress" :disabled="allProgress" @click="onSubmit">
          Сохранить
        </el-button>
      </div>
    </div>
    <div v-else class="col-12 col-xl-7">
      <div class="alert alert-warning">Настроечные параметры отсутствуют</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

const ParameterValueTypeEnum = {
  integer: 1,
  text: 2,
  double: 3,
  date: 4,
  boolean: 5,
  array: 6,
  json: 7,
};

export default {
  data() {
    return {
      ParameterValueTypeEnum,
      form: [],
    };
  },
  computed: {
    ...mapGetters({
      fetchISettingsProgress: 'commonsSettings/fetchSettingsProgress',
      updateSettingsProgress: 'commonsSettings/updateSettingsProgress',
      settings: 'commonsSettings/settings',
    }),
    settingsFiltered() {
      return this.settings.filter((s) => s.parameterDescription);
    },
    allProgress() {
      return this.fetchISettingsProgress || this.updateSettingsProgress;
    },
  },
  methods: {
    ...mapActions({
      fetchSettings: 'commonsSettings/fetchSettings',
      updateSettings: 'commonsSettings/updateSettings',
    }),
    replaceTypeText(text) {
      return text.length > 12 ? `${text.substr(0, 12)}...` : text;
    },
    replaceImageType(str) {
      return str.replace(/[^a-z0-9]/i, '');
    },
    onSubmit() {
      const settings = this.form.map(({ parameterId, parameterValueGeneral, parameterValueType }) => {
        if (parameterValueGeneral === null || typeof parameterValueGeneral === 'undefined' || Number.isNaN(parameterValueGeneral)) {
          return { parameterId, parameterValueGeneral: null };
        }
        if ([ParameterValueTypeEnum.array].includes(parameterValueType)) {
          return { parameterId, parameterValueGeneral: JSON.stringify(parameterValueGeneral) };
        }

        // if ([ParameterValueTypeEnum.integer].includes(parameterValueType)) {
        //   return { parameterId, parameterValueGeneral: parseInt(parameterValueGeneral, 10) };
        // }
        return { parameterId, parameterValueGeneral: parameterValueGeneral.toString() };
      });

      this.updateSettings({ data: { settings } });
    },

    fillForm() {
      this.form = this.settingsFiltered
        .map((s) => ({
          ...s,
          parameterValueGeneral:
            s.parameterValueType === ParameterValueTypeEnum.boolean ? JSON.parse(s.parameterValueGeneral) : s.parameterValueGeneral,
        }));
    },
  },
  watch: {
    settings() {
      this.fillForm();
    },
  },
  created() {
    this.fetchSettings();
  },
};
</script>

<style scoped lang="scss">
h4 {
  font-weight: 500;
  font-size: 14px;
}
.types-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: flex-start;
}
.button-new-image-type {
  font-size: 20px;
  padding: 0;
  align-items: center;
  height: 32px;
  width: 32px;
}
</style>
